import React, { Component } from 'react';
import {geolocated} from "react-geolocated";
import firebase from 'firebase/compat/app';
import {Form} from "react-bootstrap";
import Button from "react-bootstrap/Button";

class GeolocatedView extends Component {

    constructor() {
        super();
        this.state = {
            gpsCoords: false,
            access:false,
            notAccess: false,}
    }

    componentWillUnmount() {
        clearInterval(this.interval);
    }

    componentDidMount() {

        this.interval = setInterval(() => this.tick(), 1000);
    }

    verifyLocation = () => {
        let self = this;
        firebase.firestore().collection('EventDevices')
            .where('online', '==', true)
            .get()
            .then(snapshot => {
                if (snapshot.empty) {
                    console.log('empty');
                } else {
                    let access = false;
                    let devices = [];
                    snapshot.forEach(doc => {
                        let data = doc.data();
                        if(data.lat && data.lng) {
                            let dis = self.calculateDistance(this.props.coords.latitude, this.props.coords.longitude, data.lat, data.lng, 'K') * 1000.0; // in meters
                            if(dis < 1500.0) {
                                access = true;
                            }
                        }
                        devices.push(doc.data());
                    });
                    console.log('access: ' + access);
                    if(access){
                        //this.setState({access:true});
                        this.props.onValidated();
                    } else {
                        this.setState({notAccess:true});
                    }
                    //console.log(devices);
                }
            })
            .catch(err => {
                console.log(err);
            });
    }

    tick() {
        if(this.props.coords && !this.state.gpsCoords) {
            console.log('gps cords is ok');
            this.setState({gpsCoords:true})
            this.verifyLocation();
        }
    }

    calculateDistance(lat1, lon1, lat2, lon2, unit) {
        let radlat1 = Math.PI * lat1/180
        let radlat2 = Math.PI * lat2/180
        let radlon1 = Math.PI * lon1/180
        let radlon2 = Math.PI * lon2/180
        let theta = lon1-lon2
        let radtheta = Math.PI * theta/180
        let dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta);
        dist = Math.acos(dist)
        dist = dist * 180/Math.PI
        dist = dist * 60 * 1.1515
        if (unit=="K") { dist = dist * 1.609344 }
        if (unit=="N") { dist = dist * 0.8684 }
        return dist
    }

    refresh = () => {
        window.location.reload(true);
    }

    openGallery = () => {
        this.props.onValidated();
    }

    render() {

        let msg = 'Getting the location data...';
        if(this.state.gpsCoords) {
            msg = 'Verify your location, please wait...';
        }
        if(this.state.access){
            msg = '';
        }
        if(this.state.notAccess){
            msg = 'We could not verify your location please refresh page and allow access to your location.';
        }

        return (
            <div>
            <div className="LoginViewRoot">

                {!this.props.loading && <div className="LoginViewBody">

                    <div className="LoginViewBody2">

                        {this.props.isGeolocationEnabled && <Form.Label style={{fontSize: 14}} className="text-center">{msg}</Form.Label>}

                        {!this.props.isGeolocationEnabled && <Form.Label style={{fontSize: 14}} className="text-center">{'Your GPS seems to be turned off and we could not verify your location. Please activate GPS.'}</Form.Label>}
                        {!this.props.isGeolocationEnabled &&
                        <div className="LoginViewBody">
                            <Button onClick={this.refresh} variant="primary" type="submit" active>
                                {'Refresh'}
                            </Button>
                        </div>
                        }

                        {this.state.notAccess &&
                        <div className="LoginViewBody">
                            <Button onClick={this.refresh} variant="primary" type="submit" active>
                                {'Refresh'}
                            </Button>
                        </div>
                        }

                        {/*this.state.access &&
                            <div className="LoginViewBody2">
                                <Button onClick={this.openGallery} variant="primary" type="submit" active>
                                    {'Open gallery'}
                                </Button>
                            </div>
                        */}

                    </div>
                </div>}
            </div>

                <div className="LoginViewBody">
                    <div style={{height:1500}}></div>
                </div>

            </div>

        );

        /*return !this.props.isGeolocationAvailable ? (
            <div>Your browser does not support Geolocation</div>
        ) : !this.props.isGeolocationEnabled ? (
            <div>Geolocation is not enabled</div>
        ) : this.props.coords ? (
            <table>
                <tbody>
                <tr>
                    <td>latitude</td>
                    <td>{this.props.coords.latitude}</td>
                </tr>
                <tr>
                    <td>longitude</td>
                    <td>{this.props.coords.longitude}</td>
                </tr>
                </tbody>
            </table>
        ) : (
            <div>Getting the location data&hellip; </div>
        );*/
    }
}

export default geolocated({
    positionOptions: {
        enableHighAccuracy: false,
    },
    userDecisionTimeout: 5000,
})(GeolocatedView);
